module.exports = __webpack_public_path__ + "static/img/car.658fe23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car.png
// module id = 204
// module chunks = 1